import { g as _defineProperty, _ as _objectSpread2 } from './_rollupPluginBabelHelpers-fb970440.js';
import { makeVar } from '@apollo/client';

var _init_state_quote;
var init_state_quote$1 = (_init_state_quote = {
  get_covers: false,
  quotationNo: '',
  quotationStatus: '',
  quoteCreationDate: '',
  isSaveQuoteEnabled: false,
  isPremiumCalculated: false,
  isPremiumDisplayed: false,
  isQuoteSubmitting: false,
  proposalNumber: '',
  isQuoteSaving: false,
  currentTab: 0,
  captureMode: 'create',
  intermediaryDetails: {
    code: '',
    location: '',
    fieldUserCode: '',
    fieldUserName: ''
  },
  customerType: '',
  customerTypeValue: '',
  individualName: '',
  corporateName: '',
  addressLine1: '',
  addressLine2: '',
  addressLine3: '',
  landmark: '',
  pincode: '',
  city: '',
  stateLocation: '',
  businessClassification: '',
  businessClassificationValue: '',
  udyogAadhaarNo: '',
  policyType: '',
  policyTypeValue: '',
  policyStartDate: '',
  isGstNumberAvailable: false,
  gstNumber: '',
  voyageType: '',
  voyageTypeValue: '',
  cargoType: '',
  cargoTypeValue: '',
  cargoDescription: '',
  modeOfConveyance: '',
  modeOfConveyanceValue: '',
  coverageDetailsType: '',
  coverageDetailsTypeValue: '',
  originCountry: '',
  originCountryValue: '',
  originCity: '',
  originCityValue: '',
  destinationCountry: '',
  destinationCountryValue: '',
  destinationCity: '',
  destinationCityValue: '',
  excess: '',
  invoiceNumber: '',
  blawblrrrno: '',
  packagingType: '',
  packagingTypeValue: '',
  invoiceDate: '',
  blawbDate: '',
  sumInsuredValue: '',
  invoiceCurrency: '',
  exchangeRate: '',
  cargoSumInsured: '',
  basisOfValuationType: '',
  basisOfValuationTypeValue: '',
  loading: '',
  bovSumInsured: '',
  dutySumInsured: '',
  basicRate: '',
  totalSumInsured: '',
  warrate: '',
  srccrate: ''
}, _defineProperty(_init_state_quote, "invoiceNumber", ''), _defineProperty(_init_state_quote, "invoiceDate", ''), _defineProperty(_init_state_quote, "containerMarks", ''), _defineProperty(_init_state_quote, "originCity", ''), _defineProperty(_init_state_quote, "destinationCity", ''), _defineProperty(_init_state_quote, "policyEndDate", ''), _defineProperty(_init_state_quote, "policyPeriodInMonths", '12'), _defineProperty(_init_state_quote, "policyTenure", '1'), _defineProperty(_init_state_quote, "policyTenureValue", '1 year'), _defineProperty(_init_state_quote, "employeeDetails", []), _defineProperty(_init_state_quote, "employeeDetailsBase64String", ''), _defineProperty(_init_state_quote, "employeeDetailsExcelFileName", ''), _defineProperty(_init_state_quote, "totalNoOfEmployeesInFile", 0), _defineProperty(_init_state_quote, "addOnCovers", {}), _defineProperty(_init_state_quote, "rawRiskData", []), _defineProperty(_init_state_quote, "employeedocumentsDetails", []), _defineProperty(_init_state_quote, "coverDetails", []), _defineProperty(_init_state_quote, "documentDetails", []), _defineProperty(_init_state_quote, "clauses", []), _defineProperty(_init_state_quote, "defaultClauses", []), _defineProperty(_init_state_quote, "userDefinedClauses", []), _defineProperty(_init_state_quote, "defaultConditions", []), _defineProperty(_init_state_quote, "userDefinedConditions", []), _defineProperty(_init_state_quote, "defaultExclusions", []), _defineProperty(_init_state_quote, "userDefinedExclusions", []), _defineProperty(_init_state_quote, "defaultWarranties", []), _defineProperty(_init_state_quote, "userDefinedWarranties", []), _defineProperty(_init_state_quote, "underWriterComments", ''), _defineProperty(_init_state_quote, "loadingCalcPremium", ''), _defineProperty(_init_state_quote, "discountCalcPremium", ''), _defineProperty(_init_state_quote, "isPremiumCalculating", false), _defineProperty(_init_state_quote, "isPremiumCalculated", false), _defineProperty(_init_state_quote, "calculatedPremium", {
  netPremium: '',
  GST: '',
  totalPremium: '',
  stampDuty: ''
}), _defineProperty(_init_state_quote, "stageIndex", ''), _defineProperty(_init_state_quote, "customer", {}), _defineProperty(_init_state_quote, "customerMeta", {}), _init_state_quote);
var marineQuoteVar = makeVar(init_state_quote$1);
var initMarineVoyageQuoteState = function initMarineVoyageQuoteState(isCopyFromOutside) {
  var _marineQuoteVar;

  if (isCopyFromOutside && (_marineQuoteVar = marineQuoteVar()) !== null && _marineQuoteVar !== void 0 && _marineQuoteVar.isCopyFromOutside) {
    marineQuoteVar(_objectSpread2(_objectSpread2({}, marineQuoteVar()), {}, {
      isCopyFromOutside: false
    }));
    return true;
  }

  marineQuoteVar(init_state_quote$1);
  return false;
};
var updateMarineVoyageQuote = function updateMarineVoyageQuote(data) {
  marineQuoteVar(_objectSpread2(_objectSpread2({}, marineQuoteVar()), data));
};

var init_state_quote = {
  quotationNo: '',
  quotationStatus: '',
  quoteCreationDate: '',
  isSaveQuoteEnabled: false,
  isQuoteSubmitting: false,
  isQuoteSaving: false,
  proposalNumber: '',
  currentTab: 0,
  isApprover: '',
  captureMode: 'create',
  addOnCovers: [],
  ccew: [],
  coverData: {
    addOnCovers: [],
    rawRiskData: []
  },
  intermediaryDetails: {
    code: '',
    location: '',
    fieldUserCode: '',
    fieldUserName: ''
  },
  premium: '',
  netPremium: '',
  gst: '',
  stampDuty: '',
  //customer
  customerDetails: {
    customerType: {
      code: '',
      value: ''
    },
    orgInsuredName: '',
    firstName: '',
    middleName: '',
    lastName: ''
  },
  approval_Reason: '',
  //quote-wizard-panel-->location-details--> index.js
  insuredNameHS: '',
  riskLocationDetails: {
    riskLocationAddressLine1: '',
    riskLocationAddressLine2: '',
    riskLocationAddressLine3: '',
    riskLocationAddressLandmark: '',
    townOrCity: '',
    areaLocality: '',
    pinCode: '',
    State: '',
    country: '',
    eqZone: '',
    locationCode: '',
    district: '' //add_03_07_24

  },
  //quote-wizard-panel-->housing-details--> housing-DetailsForm.js     
  // section1: //CNG_NW_SEC-1
  // {
  isCheckedSecI: true,
  typeOfCoverI: '',
  carpetAreaI: '',
  rateofCostofConstructionI: '',
  buildingSiI: '',
  additionalStructureI: '',
  totalBuildingSiI: '',
  generalContentSiI: '',
  valuableContentSiI: '',
  totalContentSiI: '',
  totalSumInsuredI: '',
  sectionIRateI: '',
  discountPerI: '',
  loadingPerI: '',
  sectionIFinalRateI: '',
  sectionIPremiumI: '',
  netPremiumI: '',
  gstI: '',
  stampDutyI: '',
  sectionIpremium: '',
  sectionIIpremium: '',
  sectionIIIpremium: '',
  sectionIVpremium: '',
  sectionVpremium: '',
  sectionVIpremium: '',
  sectionVIIpremium: '',
  // },
  // section2: //CNG_NW_SEC-2
  // {
  isCheckedSecII: false,
  basisOfSumInsuredII: '',
  whetherPolicyOnFirstLossII: '',
  firstLossPerII: '',
  firstLossAmountII: '',
  sumInsuredII: '',
  excessII: '',
  rateII: '',
  discountII: '',
  loadingII: '',
  burglaryfinalRateII: '',
  premiumII: '',
  netPremiumII: '',
  gstII: '',
  stampDutyII: '',
  // },
  // section3: //CNG_NW_SEC-3
  // {
  isCheckedSecIII: false,
  sumInsuredIII: '',
  descriptionIII: '',
  makeModelSrNoIII: '',
  yearOfManufacturingIII: '',
  totalSumInsuredIII: '',
  excessIII: '',
  rateIII: '',
  discountPerIII: '',
  loadingIII: '',
  eeiFinalRateIII: '',
  premiumIII: '',
  netPremiumIII: '',
  gstIII: '',
  stampDutyIII: '',
  // },
  // section4:  //CNG_NW_SEC-4
  // {
  isCheckedSecIV: false,
  sumInsuredIV: '',
  descriptionIV: '',
  makeModelSrNoIV: '',
  yearOfManufacturingIV: '',
  totalSumInsuredIV: '',
  excessIV: '',
  rateIV: '',
  discountPerIV: '',
  loadingIV: '',
  mbdFinalRateIV: '',
  premiumIV: '',
  netPremiumIV: '',
  gstIV: '',
  stampDutyIV: '',
  // },
  // section5:  //CNG_NW_SEC-5
  // {
  isCheckedSecV: false,
  numberOfEmployeesV: '',
  monthlySalaryV: '',
  yearlySalaryV: '',
  sumInsuredV: '',
  totalSumInsuredV: '',
  excessV: '',
  rateV: '',
  discountPerV: '',
  loadingV: '',
  ecRateV: '',
  premiumV: '',
  netPremiumV: '',
  gstV: '',
  stampDutyV: '',
  // },
  // section6: //CNG_NW_SEC-6
  // {
  isCheckedSecVI: false,
  limitOfLiabilityEachOccurrenceVI: '',
  limitOfLiabilityAllOccurrencesVI: '',
  retroactiveDateVI: '',
  jurisdictionVI: '',
  excessVI: '',
  sumInsuredVI: '',
  rateVI: '',
  discountPerVI: '',
  loadingVI: '',
  plFinalRateVI: '',
  premiumVI: '',
  netPremiumVI: '',
  gstVI: '',
  stampDutyVI: '',
  // },
  //housing total premiun
  totalPremium: '',
  totalnetPremium: '',
  totalgst: '',
  totalstampDuty: '',
  additionalTabDetails: {
    warranties: {
      defaultWarranties: [],
      userDefinedWarranties: []
    },
    exclusions: {
      defaultExclusions: [],
      userDefinedExclusions: []
    },
    clauses: {
      defaultClauses: [],
      userDefinedClauses: []
    },
    conditions: {
      defaultConditions: [],
      userDefinedConditions: []
    },
    underwriterComments: '' //underwriterComment: '',//chng_03_07_24

  },
  tabDetails: {
    customerTabDetails: {
      customerDetails: {
        customer: {},
        customerMeta: {} // customerType: {
        //   code: '',
        //   value: '',
        // },
        // firstName: '',
        // middleName: '',
        // lastName: '',
        // orgInsuredName: '',

      },
      policyTenure: {
        code: '',
        value: ''
      },
      policyStartDate: '',
      policyExpiryDate: ''
    }
  }
};
var housingSecQuoteVar = makeVar(init_state_quote);
var initHousingSocityQuoteState = function initHousingSocityQuoteState(isCopyFromOutside) {
  var _housingSecQuoteVar;

  if (isCopyFromOutside && (_housingSecQuoteVar = housingSecQuoteVar()) !== null && _housingSecQuoteVar !== void 0 && _housingSecQuoteVar.isCopyFromOutside) {
    housingSecQuoteVar(_objectSpread2(_objectSpread2({}, housingSecQuoteVar()), {}, {
      isCopyFromOutside: false
    }));
    return true;
  }

  housingSecQuoteVar(init_state_quote);
  return false;
};
var updateHousingSocityQuote = function updateHousingSocityQuote(data) {
  //console.log("inside update", data);
  housingSecQuoteVar(_objectSpread2(_objectSpread2({}, housingSecQuoteVar()), data));
};
var updateQuotationDetails = function updateQuotationDetails(quotationNo, quotationStatus, quoteCreationDate) // addOnCovers,
// rawRiskData,
{
  // if (addOnCovers && rawRiskData) {
  //   workCompQuoteVar({
  //     ...workCompQuoteVar(),
  //     quotationNo: quotationNo,
  //     quotationStatus: quotationStatus,
  //     quoteCreationDate: quoteCreationDate,
  //     addOnCovers,
  //     rawRiskData,
  //   });
  // } else {
  housingSecQuoteVar(_objectSpread2(_objectSpread2({}, housingSecQuoteVar()), {}, {
    quoteNumber: quotationNo,
    status: quotationStatus,
    quoteCreationDate: quoteCreationDate
  })); // }
};

export { updateHousingSocityQuote as a, updateQuotationDetails as b, initHousingSocityQuoteState as c, housingSecQuoteVar as h, initMarineVoyageQuoteState as i, marineQuoteVar as m, updateMarineVoyageQuote as u };
